import { create } from "zustand";

import type { CSATFeature } from "@/api/generated/models";
import type { SurveyQuestion } from "@/survey/constants";

export type CSATSurveyDisplay = {
  surveyKey: CSATFeature;
  questions: SurveyQuestion[];
  conversationId?: string;
  encounterId?: string | null;
};

type CSATSurveyStore = {
  currentSurvey: CSATSurveyDisplay | null;
  showSurvey: (survey: CSATSurveyDisplay) => void;
  clearSurvey: () => void;
};

export const useCSATSurveyStore = create<CSATSurveyStore>()((set) => ({
  currentSurvey: null,
  showSurvey: (currentSurvey) => set({ currentSurvey }),
  clearSurvey: () => set({ currentSurvey: null }),
}));
